import Rebut from "../../../model/multilleure/rebuts/Rebut";

const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteRemesa = async ( id_remesa: number, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/remeses/${id_remesa}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            return "ERROR";
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
